import { render, staticRenderFns } from "./QCharityName.vue?vue&type=template&id=7931935f&scoped=true"
import script from "./QCharityName.vue?vue&type=script&lang=js"
export * from "./QCharityName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7931935f",
  null
  
)

export default component.exports